import { render, staticRenderFns } from "./photo-modal.component.vue?vue&type=template&id=196a400e&"
import script from "./photo-modal.component.vue?vue&type=script&lang=ts&"
export * from "./photo-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./photo-modal.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "photo-modal.component.vue"
export default component.exports